import { loadOptions } from '../../versa/formset.js';
import db from '../../versa/db.js';
import { replaceIndex, REGEX } from '../../versa/table.js';

/** CFOPs do cadastro: Entrada → 1/2/3xxx; Saída e Ativo → 5/6/7xxx. */
function cfopMatchesIoType(code, ioType)
{
	const s = String(code || '').trim();
	if (s.length < 1) return false;
	const f = s[0];
	if (ioType === 'I')
		return f === '1' || f === '2' || f === '3';
	if (ioType === 'O' || ioType === 'A')
		return f === '5' || f === '6' || f === '7';
	return true;
}

export default function ()
{
	const SHARED = { _this: null };

	return {

		captureEvents(_this = this)
		{
			this.hook();
			this.safeProtoCall(_this);
		},

		hook()
		{
			['company_id', 'io_type'].forEach(name =>
			{
				const id = this.makeId(name);
				const field = this.locate(id);
				if (!field)
					throw new Error(`obs_cfops_invoice: campo não encontrado: ${id}`);
				field.subscribe(['change'], this.actions.bind(this), false);
			});
		},

		makeId(name)
		{
			const parts = this.getIdParts();
			const form = parts[1];
			const index = parts[3];
			if (name.match(REGEX) && index)
				name = replaceIndex(name, index.substr(1));
			return form + name;
		},

		getIdParts()
		{
			return this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
		},

		async preventMultiCalls(object, primary_callback, secondary_callback)
		{
			const listAttr = document.querySelector(this.selector)?.getAttribute('list');
			const is_datalist_indexed = Boolean(listAttr && REGEX.test(listAttr));
			const is_action_ongoing = Boolean(object._this);
			if (!is_datalist_indexed && is_action_ongoing)
				object._this.subscribe(['done'], secondary_callback);
			else
			{
				object._this = this;
				await primary_callback();
				if (!is_datalist_indexed)
					object._this.publish('done');
				object._this = null;
			}
		},

		async actions()
		{
			const run = async () =>
			{
				let cid = this.locate('company_id')?.getValue?.();
				if (typeof cid === 'string' && /^\d+$/.test(cid))
					cid = Number(cid);
				const io = this.locate('io_type')?.getValue?.() || 'O';
				if (!cid)
				{
					loadOptions(this.selector, [], 'code', ['code', 'description'], ': ');
					this.refresh();
					return;
				}
				const range = IDBKeyRange.bound([cid, ''], [cid, '\uffff']);
				let data = await db.list('cfops', range, 2);
				data = (data || []).filter(r => !r.is_disabled);
				data = data.filter(r => cfopMatchesIoType(r.code, io));
				loadOptions(this.selector, data, 'code', ['code', 'description'], ': ');
				this.refresh();
			};
			await this.preventMultiCalls(SHARED, run, () => this.refresh());
		},
	};
}
